(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nakame-quote-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nqf-root]').forEach((root) => {
    const eventType = root.querySelector('[data-event-type]');
    const serviceInputs = Array.from(root.querySelectorAll('[data-service]'));
    const allServiceInputs = Array.from(root.querySelectorAll('.nqf__choices input[type="checkbox"]'));

    const setVisibility = (condition, visible) => {
      root.querySelectorAll(`[data-condition="${condition}"]`).forEach((container) => {
        container.hidden = !visible;
        container.querySelectorAll('[data-conditional-required]').forEach((input) => {
          input.required = visible;
        });
      });
    };

    const update = () => {
      const eventValue = eventType ? eventType.value : '';
      setVisibility('birthday', eventValue === 'Anniversaire');
      setVisibility('event-other', eventValue === 'Autre');
      if (allServiceInputs.length > 0) {
        const hasSelectedService = allServiceInputs.some((input) => input.checked);
        allServiceInputs[0].required = !hasSelectedService;
      }
      ['photo', 'decor', 'gourmand'].forEach((group) => {
        const selected = serviceInputs.some((input) => input.dataset.service === group && input.checked);
        setVisibility(group, selected);
      });
    };

    root.addEventListener('change', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
